import { fetchAllTripsAction as psearchFetchAllTripsAction } from 'wanderu-ducks-psearch';

import { DEPART_DIRECTION, RETURN_DIRECTION } from '../../constants';
import * as searchSelectors from '../search/selectors';
import * as types from './types';

function resubmitPsearchForSeats(seats) {
    return (dispatch, getState) => {
        const state = getState();
        [DEPART_DIRECTION, RETURN_DIRECTION].forEach((direction) => {
            const basePsearchParams = searchSelectors.selectPSearchParams(state, { direction });
            if (!basePsearchParams) return;
            const psearchParams = { ...basePsearchParams, seats };
            dispatch(psearchFetchAllTripsAction.reset(psearchParams));
            dispatch(psearchFetchAllTripsAction.fetch(psearchParams));
        });
    };
}

function setTravelerInfo(data) {
    return {
        payload: data,
        type: types.SET_TRAVELER_INFO,
    };
}

function resetTravelerInfo() {
    return {
        type: types.RESET_TRAVELER_INFO,
    };
}

function setDepartTripId(tripId) {
    return {
        type: types.SET_DEPART_TRIP_ID,
        meta: tripId,
    };
}

function setReturnTripId(tripId) {
    return {
        type: types.SET_RETURN_TRIP_ID,
        meta: tripId,
    };
}

function removeTripIds() {
    return {
        type: types.REMOVE_TRIP_IDS,
    };
}

function setFareClass(data) {
    return {
        payload: data,
        type: types.SET_FARE_CLASS,
    };
}

export {
    removeTripIds,
    resetTravelerInfo,
    resubmitPsearchForSeats,
    setDepartTripId,
    setFareClass,
    setReturnTripId,
    setTravelerInfo,
};
